import React from "react";
import { withStyles } from '@mui/styles';

import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Typography from '@mui/material/Typography';

// TODO change to SVG or other format
import addToSlackActiveImage from '../img/steps/add_to_slack_red.png';
import authorizeActiveImage from '../img/steps/authorize_red.png';
import loginSlackActivekImage from '../img/steps/login_slack_red.png';
import planActiveImage from '../img/steps/plan_red.png';
import cardActiveImage from '../img/steps/card_red.png';
import addToSlackImage from '../img/steps/add_to_slack_gray.png';
import authorizeImage from '../img/steps/authorize_gray.png';
import loginSlacmage from '../img/steps/login_slack_gray.png';
import planImage from '../img/steps/plan_gray.png';
import cardImage from '../img/steps/card_gray.png';

const useStyles = theme => ({
    '@global': {
    },
    'stepLabel': {
        'textAlign': 'center',
        'fontSize': '10px',
        'padding': '0px 0px',
        'margin': '10px 0px',
    },
    'stepIcon': {
        'fontSize': '40px',
    }
});

// reference https://material-ui.com/components/steppers/
class SignUpSteps extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            openStep1: false,
            openStep2: false,
        };
    }
    stepIcons(props) {
        const { active } = props;
        console.log(active)
        const inActiveIcons: { [index] : React.ReactElement } = { //
            1: <img alt="1" src={addToSlackImage} width="100" />,
            2: <img alt="2" src={authorizeImage} width="100" />,
            3: <img alt="3" src={loginSlacmage} width="100" />,
            4: <img alt="4" src={planImage} width="100" />,
            5: <img alt="5" src={cardImage} width="100" />,
        };
        const activeIcons: { [index] : React.ReactElement } = { //
            1: <img alt="1" src={addToSlackActiveImage} width="100" />,
            2: <img alt="2" src={authorizeActiveImage} width="100" />,
            3: <img alt="3" src={loginSlackActivekImage} width="100" />,
            4: <img alt="4" src={planActiveImage} width="100" />,
            5: <img alt="5" src={cardActiveImage} width="100" />,
        };
        const icons = active ? activeIcons : inActiveIcons;
        return (
            <div>
                {icons[String(props.icon)]}
            </div>
        );
    }
    step1ImageBox() {
        return <Typography>
            Authorize app to access your Slack workspace
            <img src={addToSlackImage} alt="step1" style={ { display: "block", maxWidth: "290px" }} />
        </Typography>
    }
    step2ImageBox() {
        return <Typography>
            Authorize app to access your Slack user info
            <img src={authorizeImage} alt="step2" style={ { display: "block", maxWidth: "290px"  }}/>
        </Typography>
    }
    step3ImageBox() {
        return <Typography>
            Authorize app to access your Slack user info
            <img src={loginSlacmage} alt="step3" style={ { display: "block", maxWidth: "290px"  }}/>
        </Typography>
    }
    step4ImageBox() {
        return <Typography>
            Authorize app to access your Slack user info
            <img src={planImage} alt="step4" style={ { display: "block", maxWidth: "290px"  }}/>
        </Typography>
    }
    step5ImageBox() {
        return <Typography>
            <img src={cardImage} alt="step5" style={ { display: "block", maxWidth: "290px"  }}/>
            <p>Card Info</p>
        </Typography>
    }
    op(item) {
        alert(item);
    }
    render() {
        const steps = [
            { text: 'Add to Slack', image: addToSlackImage, activeImage: addToSlackActiveImage, popup: this.step1ImageBox }, 
            { text: 'Authorize', image: authorizeImage, activeImage: authorizeActiveImage, popup: this.step2ImageBox },
            { text: 'Login', image: loginSlacmage, activeImage: loginSlackActivekImage,  popup: this.step3ImageBox },
            { text: 'Count user', image: planImage, activeImage: planActiveImage,  popup: this.step4ImageBox },
            { text: 'Card info', image: cardImage, activeImage: cardActiveImage, popup: this.step5ImageBox },
        ];
        const { activeStep, classes } = this.props;
        return (
            <React.Fragment>
                <Stepper activeStep={activeStep} connector={null} alternativeLabel>
                    {steps.map((step) => (
                    <Step key={step.text}>
                        <StepLabel StepIconComponent={this.stepIcons}>
                            
                        </StepLabel>
                    </Step>
                    ))}
                </Stepper>
            </React.Fragment>
        )
    }
}
export default withStyles(useStyles)(SignUpSteps);